import type { TrigKey } from './keys';

export const ur: Partial<Record<TrigKey, string>> = {
  'app.eyebrow': 'ریاضی · مثلثیات',
  'panel.experiment': 'تجربہ',
  'panel.params': 'پیرامیٹرز',
  'panel.scene': 'تجربہ چنیں',
  'experiment.right-triangle.label': 'قائم الزاویہ مثلث',
  'experiment.unit-circle.label': 'وحدت دائرہ',
  'experiment.wave-studio.label': 'موج اسٹوڈیو',
  'experiment.identity-playground.label': 'مساویات',
  'experiment.triangle-solver.label': 'مثلث حل',
  'experiment.circular-polar.label': 'گول و قطبی',
  'hint.line1': 'نقاط گھسیٹیں اور سلائیڈر چلائیں۔',
  'hint.line2': 'تعلیمی مواد ہندسے میں ہے، متن میں نہیں۔',
  'rt.angle.a': 'زاویہ A',
  'rt.angle.b': 'زاویہ B',
  'rt.angle.value': '∠',
  'rt.units.rad': 'ریڈین',
  'rt.show.sin': 'sin',
  'rt.show.cos': 'cos',
  'rt.show.tan': 'tan',
  'rt.snap': '30°/45°/60° پر سنیپ',
  'uc.units': 'اکائیاں',
  'uc.show.sin': 'sin',
  'uc.show.cos': 'cos',
  'uc.show.tan': 'tan',
  'uc.show.csc': 'csc',
  'uc.show.sec': 'sec',
  'uc.show.cot': 'cot',
  'uc.show.astc': 'ASTC دکھائیں',
  'uc.snap.common': 'عام زاویوں پر سنیپ',
  'uc.angle.value': '∠',
  'uc.units.deg': 'ڈگری',
  'uc.units.rad': 'رد',
  'uc.units.both': 'ڈگری+رد',
  'ws.fn': 'فعل',
  'ws.fn.sin': 'sin',
  'ws.fn.cos': 'cos',
  'ws.fn.tan': 'tan',
  'ws.fn.csc': 'csc',
  'ws.fn.sec': 'sec',
  'ws.fn.cot': 'cot',
  'ws.amplitude': 'A — وسعت',
  'ws.frequency': 'B — تعدد',
  'ws.phase': 'C — مرحلی تبدیلی',
  'ws.shift': 'D — عمودی شفٹ',
  'ws.rform.toggle': 'R-شکل اخذ',
  'ws.rform.a': 'a (sin گتانک)',
  'ws.rform.b': 'b (cos گتانک)',
  'ws.rform.r': 'R',
  'ws.rform.alpha': 'α',
  'ws.reset': 'ری سیٹ',
  'ws.base': 'بنیادی منحنی',
  'ip.id.pythagorean': 'فیثاغورثی',
  'ip.id.reciprocal': 'الٹا',
  'ip.id.quotient': 'تقسیم',
  'ip.id.sum': 'جمع',
  'ip.id.difference': 'تفریق',
  'ip.id.double': 'دوگنا زاویہ',
  'ip.id.half': 'نصف زاویہ',
  'ip.play': 'چلائیں',
  'ip.pause': 'رکوک',
  'ip.step': 'قدم',
  'ip.reset': 'ری سیٹ',
  'ip.proof.pythagorean.summary': 'sin²θ + cos²θ = 1',
  'ip.proof.reciprocal.summary': 'csc θ = 1/sin θ,  sec θ = 1/cos θ,  cot θ = 1/tan θ',
  'ip.proof.quotient.summary': 'tan θ = sin θ / cos θ',
  'ip.proof.sum.summary': 'sin(A+B) = sin A cos B + cos A sin B',
  'ip.proof.difference.summary': 'sin(A−B) = sin A cos B − cos A sin B',
  'ip.proof.double.summary': 'sin 2θ = 2 sin θ cos θ',
  'ip.proof.half.summary': 'sin(θ/2) = ±√((1 − cos θ)/2)',
  'ip.proof.v2.note': 'v2 میں — اس ثبوت کو زیادہ تفصیلی تعمیر چاہیے۔',
  'ts.area': 'رقبہ',
  'ts.sineRule': 'sine قانون',
  'ts.cosineRule': 'cosine قانون',
  'ts.ambiguous.toggle': 'مبہم پر بھوت مثلث',
  'ts.reset': 'مساوی الاضلاع پر ری سیٹ',
  'ts.snap.integers': 'صحیح اعداد پر سنیپ',
  'ts.side.a': 'a',
  'ts.side.b': 'b',
  'ts.side.c': 'c',
  'ts.angle.A': 'A',
  'ts.angle.B': 'B',
  'ts.angle.C': 'C',
  'ts.section.sides': 'اضلاع',
  'ts.section.angles': 'زاویے',
  'ts.section.sineRule': 'sine قانون',
  'ts.section.cosineRule': 'cosine قانون',
  'ts.section.area': 'رقبہ',
  'cp.omega': 'زاویائی رفتار',
  'cp.plot.y': 'y پلاٹ (sin)',
  'cp.plot.x': 'x پلاٹ (cos)',
  'cp.polar.label': 'قطبی شکل',
  'cp.polar.circle': 'دائرہ (r = 1)',
  'cp.polar.rose': 'گلاب (r = sin 3θ)',
  'cp.polar.cardioid': 'دل نما (r = 1 + cos θ)',
  'cp.polar.limacon': 'لیماسن (r = 1 − 2 cos θ)',
  'cp.smallAngle': 'چھوٹے زاویہ تقریب (sin x ≈ x)',
  'cp.play': 'چلائیں',
  'cp.pause': 'رکوک',
  'cp.reset': 'ری سیٹ',
  'cp.step': 'قدم π/12',
};
